// import ArgonBox from 'components/ArgonBox'
// import ArgonTypography from 'components/ArgonTypography'
// import React from 'react'
// import Table from 'examples/Tables/Table'
// import InvoiceTableData from "Views/people/parents/parentProfile/data/invoiceViewTableData"
// import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
// import DashboardNavbar from 'examples/Navbars/DashboardNavbar'


// function invoiceView() {
//     const{columns,rows} = InvoiceTableData;
//   return (
//     <DashboardLayout>
//         <DashboardNavbar/>
//      <ArgonBox py={3}>
//                <ArgonBox
//                         sx={{
//                           "& .MuiTableRow-root:not(:last-child)": {
//                             "& td": {
//                               borderBottom: ({ borders: { borderWidth, borderColor } }) =>
//                                 `${borderWidth[1]} solid ${borderColor}`,
//                             },
//                           },
//                         }}
//                       >
//                         <Table columns={columns} rows={rows} />
//                       </ArgonBox>
//           </ArgonBox>
//           </DashboardLayout>
//   )
// }

// export default invoiceView



/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
// @mui material components

import Card from "@mui/material/Card";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
// Argon Dashboard 2 MUI examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import Grid from "@mui/material/Grid";
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
// Data
import InvoiceTableData from "Views/people/parents/parentProfile/data/invoiceViewTableData";
import { useState} from "react";
import ArgonInput from "components/ArgonInput";
import ApnaTabs from "components/ApnaTabs/ApnaTabs";
import DeleteDialog from "components/DeleteDialog/DeleteDialog";
import { height, width } from "@mui/system";
import ArgonButton from "components/ArgonButton";
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker";
import dayjs from "dayjs";

function Tables() {
    //popup
    const[deleteDialog, setDeleteDialog] = useState(false);
    // Delete button click handler
    const handleDeleteClick = () => {
      setDeleteDialog(true);
    };

    // Close dialog
    const handleCloseDialog = () => {
      setDeleteDialog(false);
    };

    const [dob, setDob] = useState(dayjs());

  const { columns, rows } = InvoiceTableData;
 
   
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card>
            <ArgonBox p={3}>


  <ArgonBox  mb={2}>

  <ArgonBox  display="flex" justifyContent="space-between" alignItems="center" gap={1} >
        <CustomDatePicker
           label="Filters"
          value={dob}
          onChange={(newValue) => setDob(newValue)}
          width={150}
          maxDate={dayjs()} // future date disable
        />
    <ArgonBox display="flex" alignItems="center" gap={1} >
            <ArgonButton color="primary" variant="contained" size="small" >Clear</ArgonButton>
    <ArgonInput
        placeholder="search"
        name="search"
        size="small"
        type="text"
        variant="outlined"
      />
        </ArgonBox>
   
  </ArgonBox>
     
  </ArgonBox>
</ArgonBox>

            <ArgonBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              <Table columns={columns} rows={rows} />
            </ArgonBox>
          </Card>
        </ArgonBox>

        {/* dialog popup */}
        <DeleteDialog
         open={deleteDialog}
         onClose={handleCloseDialog}
         onConfirm={handleCloseDialog}
         title="Delete Tutor"
         description="Are you sure you want to delete this tutor?"
         confirmText="Delete Tutor"
         cancelText="Cancel"
      />
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
